export default __webpack_public_path__ + "static/media/dg-girl.16f284cb.webp";